import styled from 'styled-components';

export const ScreenCentered = styled.div`
    display: grid;
    height: 100%;
    width: 100%;
    text-align: center;
    align-content: center;
    justify-content: center;
    grid-template-columns: 1fr;
`;

export const Striped = styled.section`
    @media (min-width: 1024px) {
        padding: 80px 30px;
    }
    @media (max-width: 1023px) {
        padding: 30px 30px;
    }
    &:nth-child(even) {
      background-color: rgba(246,249,252, 0.5);
    }
`;

export const ThemedHeader = styled.h1`
    font-size: 30px;
    font-family: 'Special Elite', cursive;
    text-align: center;
`;

export const Row = styled.div`
    margin: auto;
    text-align: justify;
    display: grid;
    align-items: center;
    justify-items: center;
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    max-width: 1263px;
    @media (min-width: 1024px) {
        font-size: 20px;
    }
    @media (max-width: 1023px) {
        font-size: 16px;
    }
`;

export const TwoColumnRow = Row.extend`
    @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
    }
    @media (max-width: 767px) {
        grid-template-columns: 1fr;
        .mobile-row-1 {
            grid-row: 1;
        }

        .mobile-row-2 {
            grid-row: 2;
        }
    }
`;

export const FormRow = Row.extend`
    text-align: center;
    @media (min-width: 1024px) {
        grid-template-columns: 1fr 2fr;
    }
    @media (max-width: 1023px) {
        grid-template-columns: 1fr;
        grid-row-gap: 0;
        padding-bottom: 30px;
    }
`;

export const StandaloneForm = styled.form`
    width: 100%;
    margin: auto;
    text-align: center;
    @media (min-width: 1024px) {
        width: 800px;
    }
    @media (max-width: 1023px) {
        padding: 0 30px;
    }
`;

export const ThreeInputGroup = styled.div`
    display: grid;
    @media (min-width: 667px) {
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 30px;
    }
    @media (max-width: 666px) {
        grid-template-columns: 1fr;
    }
`;

export const Picture = styled.img`
    max-width: 100%;
    border-radius: 1em;
`;

export const VideoContainer = styled.div`
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    max-width: 100%;
    border-radius: 1em;
    overflow: hidden;
`;

export const Video = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    border-width: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
`;

export const LargeText = styled.span`
    @media (min-width: 768px) {
        font-size: 20px;
    }
    @media (max-width: 767px) {
        font-size: 16px;
    }
`;



// WEBPACK FOOTER //
// ./src/app/Styled.js